import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import api from "../lib/api";
import { PageHeader } from "../components/common";
import { Button } from "../components/ui/button";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";
import { AnagraficaSection, CondizioniSection } from "../components/supplier/SupplierInfo";
import { DiscountsSection, CostsSection } from "../components/supplier/ItemSections";
import DocumentsSection from "../components/supplier/DocumentsSection";
import Simulator from "../components/supplier/Simulator";
import ExpensesSection from "../components/supplier/ExpensesSection";
import { ConfirmDelete } from "../components/supplier/FieldsDialog";

const TABS = [["anagrafica", "Anagrafica"], ["sconti", "Scontistiche"], ["trasporti", "Trasporti e spedizioni"], ["imballaggi", "Imballaggi e spese"], ["condizioni", "Condizioni commerciali"], ["documenti", "Listini e documenti"], ["spese", "Storico spese"], ["simulatore", "Simulatore costo"]];

export default function FornitoreDetail() {
  const { id } = useParams();
  const nav = useNavigate();
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") || "anagrafica";
  const [sup, setSup] = useState(null);
  const [discounts, setDiscounts] = useState([]);
  const [costs, setCosts] = useState([]);

  const loadSup = async () => { const { data } = await api.get("/suppliers"); const s = data.find((x) => x.id === id); if (!s) { toast.error("Fornitore non trovato"); nav("/fornitori"); } else setSup(s); };
  const loadItems = async () => {
    const [d, c] = await Promise.all([api.get(`/discounts?supplier_id=${id}`), api.get(`/supplier-costs?supplier_id=${id}`)]);
    setDiscounts(d.data); setCosts(c.data);
  };
  useEffect(() => { loadSup(); loadItems(); /* eslint-disable-next-line */ }, [id]);

  const del = async () => { try { await api.delete(`/suppliers/${id}`); toast.success("Fornitore eliminato"); nav("/fornitori"); } catch (e) { toast.error(e?.response?.data?.detail || "Eliminazione non riuscita"); } };
  if (!sup) return <div className="p-8 text-muted-foreground">Caricamento…</div>;
  const counts = { sconti: discounts.length, trasporti: costs.filter((c) => c.type === "trasporto").length, imballaggi: costs.filter((c) => c.type !== "trasporto").length };

  return (
    <div>
      <PageHeader title={sup.name} subtitle={[sup.contact, sup.phone, sup.email].filter(Boolean).join(" · ") || "Scheda fornitore"}>
        <Button variant="outline" data-testid="sup-back" onClick={() => nav("/fornitori")}><ArrowLeft size={16} className="mr-1" /> Fornitori</Button>
        <ConfirmDelete testid="sup-delete" onConfirm={del} />
      </PageHeader>
      <div className="flex gap-2 overflow-x-auto pb-2 mb-4 -mx-1 px-1">
        {TABS.map(([k, l]) => (
          <button key={k} data-testid={`sup-tab-${k}`} onClick={() => setParams({ tab: k }, { replace: true })}
            className={`text-sm px-4 py-2 rounded-full border whitespace-nowrap transition-colors ${tab === k ? "bg-brand text-white border-brand" : "bg-white"}`}>
            {l}{counts[k] ? ` (${counts[k]})` : ""}
          </button>
        ))}
      </div>
      {tab === "anagrafica" && <AnagraficaSection sup={sup} onSaved={setSup} />}
      {tab === "sconti" && <DiscountsSection supplierId={id} items={discounts} onChanged={loadItems} />}
      {tab === "trasporti" && <CostsSection testid="sec-trasporti" supplierId={id} items={costs} types={["trasporto"]} onChanged={loadItems} />}
      {tab === "imballaggi" && <CostsSection testid="sec-imballaggi" supplierId={id} items={costs} types={["imballaggio", "altro"]} onChanged={loadItems} />}
      {tab === "condizioni" && <CondizioniSection sup={sup} onSaved={setSup} />}
      {tab === "documenti" && <DocumentsSection supplierId={id} />}
      {tab === "spese" && <ExpensesSection supplierId={id} />}
      {tab === "simulatore" && <Simulator sup={sup} discounts={discounts} costs={costs} />}
    </div>
  );
}
